import { URLs } from '../config'
import axios from 'axios'
import store from '@/store'
import http from './http'

const sign = axios.create({
    baseURL: process.env.VUE_APP_API
})

sign.interceptors.request.use(
    config => {
        if (config['url'] === '/v1/members/refresh-token') {
            config['headers'] = {
                Accept: "application/json, text/plain, */*",
                CurrentToken: `Bearer ${localStorage.getItem('accessToken')}`,
                RefreshToken: `Bearer ${localStorage.getItem('refreshToken')}`
            }
            console.log("sign.interceptor.request:: ", config);
        }

        return config
    }
)

const instanceReseponse = sign.interceptors.response.use(
    response => {
        return response
    },
    error => {

        axios.interceptors.response.eject(instanceReseponse);

        if (error.response.status === 401) {
            console.log("refresh-token is expired...")
            store.commit('OPEN_SYSTEM_BAR', {
                message: '사용자 인증시간이 만료되었습니다. 다시 로그인 해주세요.',
                color: 'info'
            })
            store.dispatch('LOGOUT')
        } else if (error.response.status === 403) {
            console.log("refresh-token is not correct...")
            store.commit('OPEN_SYSTEM_BAR', {
                message: '잘못된 인증요청입니다. 다시 로그인 해주세요.',
                color: 'warning'
            })
            store.dispatch('LOGOUT')
        }

    }
)

// NOTE: Replace object to FormData to send a server as multipart/data
export const objectToFormdata = data => {
    let changeFormDataEntries = new FormData()

    for (var [key, value] of Object.entries(data)) {
        changeFormDataEntries.append(key, value)
        console.log(key, value)
    }

    return changeFormDataEntries;
};

export const datetimezone = data => {
    return data === 'kor' ?
        new Date(Date.now() - (new Date().getTimezoneOffset() * (6 * 10000))) :
        new Date().toISOString()
}

export const auth = {
    get: {
        // @Url /v1/auth/reset-phone-check
        resetPhoneCheck: async(params) => {
            return await sign.get(
                `${URLs.auth}/reset-phone-check`, {
                    params: params,
                }
            )
        },
        // @Url /v1/auth/qrcode-login
        qrcodeLogin: async(params) => {
            return await sign.get(
                `${URLs.auth}/qrcode-login`, {
                    params: params
                }
            )
        },
        // @Url /v1/auth/qrcode
        qrcode: async() => {
            return await sign.get(
                `${URLs.auth}/qrcode`,
            )
        },
        // @Url /v1/auth/openapi/search/ltcare-insts
        itcareInstitute: async(params) => {
            return await sign.get(
                `${URLs.auth}/openapi/search/ltcare-insts`, {
                    params: params
                }
            )
        },
        // @Url /v1/auth/detailcodes/${gcode}
        groupCodes: async(params) => {
            return await sign.get(
                `${URLs.auth}/detailcodes/${params.GCode}`, {
                    params: {
                        referenceDetailCode: params.RCode
                    }
                },
            )
        },
        // @Url /v1/members/contract/{luidx}
        contract: async(params) => {
            return await http.get(
                `${URLs.members}/contract/${params.luidx}`, {
                    params: params
                },
            )
        },
        // @Url /v1/mypage/payslip
        // payslip: async (params) => {
        //     return await http.get(
        //         `${URLs.mypage}/payslip`,
        //         {
        //             params: params
        //         },
        //     )
        // },
        // @Url /v1/mypage/payslip-detail
        // payslipDetail: async (params) => {
        //     return await http.get(
        //         `${URLs.mypage}/payslip-detail`,
        //         {
        //             params: params
        //         },
        //     )
        // },
        // @Url /v1/auth/common/sign-info
        signInfo: async(params) => {
            return await http.get(
                `${URLs.auth}/common/sign-info`, {
                    params: params
                }
            )
        },
        // @Url /v1/auth/common-sign/list
        commonSignList: async(params) => {
            return await http.get(
                `${URLs.auth}/common-sign/list`, {
                    params: params
                }
            )
        },
    },
    post: {
        // @Url /v1/auth/reset-pwd
        resetPwd: async(params) => {
            let formData = objectToFormdata(params)
            return await sign.post(
                `${URLs.auth}/reset-pwd`, formData
            )
        },
        // @Url /v1/auth/confirm-authno
        confirm: async(params) => {
            let formData = objectToFormdata(params)
            return await sign.post(
                `${URLs.auth}/confirm-authno`, formData
            )
        },
        // @Url /v1/auth/change-pwd
        changePwd: async(params) => {
            let formData = objectToFormdata(params)
            return await sign.post(
                `${URLs.auth}/change-pwd`, formData
            )
        },
        // @Url /v1/auth/reset-phone-no
        resetPhoneNo: async(params) => {
            let formData = objectToFormdata(params)
            return await sign.post(
                `${URLs.auth}/reset-phone-no`, formData
            )
        },
        // @Url /v1/auth/members
        members: async(params) => {
            let formData = objectToFormdata(params)
            return await sign.post(
                `${URLs.auth}/members`, formData
            )
        },
        // @Url /v1/auth/web-login
        webLogin: async(params) => {
            let formData = objectToFormdata(params)
            return await sign.post(
                `${URLs.auth}/web-login`, formData
            )
        },
        // @Url /v1/auth/customers/home
        customersH: async(params) => {
            let formData = objectToFormdata(params)
            return await sign.post(
                `${URLs.auth}/customers/home`, formData
            )
        },
        // @Url /v1/auth/common-sign
        commonSign: async(params) => {
            let formdata = objectToFormdata(params)
            return await sign.post(
                `${URLs.auth}/common-sign`, formdata
            )
        },
    },
}

export const common = {
    get: {
        // @Url /v1/customers/{cbidx}/program-version
        programVersion: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/program-version`, {
                    params: params
                }
            )
        },
        // @Url /v1/members/signature/{luidx}
        signature: async(params) => {
            return await http.get(
                `${URLs.members}/signature/${params.luidx}`,
            )
        },
        // @Url /v1/members/detail-info/{luidx}
        detailInfo: async(params) => {
            return await http.get(
                `${URLs.members}/detail-info/${params.luidx}`, {
                    params: params,
                }
            )
        },
        // @Url /v1/members/refresh-token
        autoRefreshToken: async(params) => {
            return await sign.get(
                `${URLs.members}/refresh-token`, {
                    params: { luidx: params.luidx }
                }
            )
        },
        // @Url /v1/detailcodes/{gcode}
        groupCodes: async(params) => {
            return await http.get(
                `/v1/detailcodes/${params.GCode}`, {
                    params: {
                        referenceDetailCode: params.RCode
                    }
                }
            )
        },
        // @Url download file arraybuffer
        downloadFile: async(params) => {
            return await http.get(
                params.url, {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx
                    },
                    responseType: "arraybuffer"
                }
            )
        },
        // @Url /v1/sns-post/main/{luidx}
        main: async(params) => {
            return await http.get(
                `${URLs.sns}/main/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report/search
        stateReportSearch: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/state-report/search`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report-all 
        stateReportAll: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/state-report-all`, {
                    params: params
                }
            )
        },
        // @Url /v1/pushs/notices/{luidx}
        notices: async(params) => {
            return await http.get(
                `${URLs.pushs}/notices/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/read-file/{idx}
        ruleRead: async(params) => {
            return await http.get(
                `/v1/read-file/${params.fidx}`, {
                    params: params,
                }
            )
        },
        // @Url /v1/members/{cbidx}/signature/{idx}
        commonSignature: async(params) => {
            return await http.get(
                `${URLs.members}/${params.cbidx}/signature/${params.idx}`, {
                    params: params,
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report/{idx}/{rIdx}
        stateReport: async(params) => {
            return await http.get(
                `${URLs.recipients}/${params.cbidx}/state-report/${params.idx}/${params.ridx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/auth/openapi/search/medicine-info
        medicineInfo: async(params) => {
            return await http.get(
                `${URLs.auth}/openapi/search/medicine-info`, {
                    params: params
                }
            )
        },
        // @Url /v1/auth/openapi/search/hospital
        hospital: async(params) => {
            return await http.get(
                `${URLs.auth}/openapi/search/hospital`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/certificate
        certificate: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/certificate`, {
                    params: params
                }
            )
        },
        // @Url /v1/auth/recipients/guardian-sign
        guardianSign: async(params) => {
            return await http.get(
                `${URLs.auth}/recipients/guardian-sign`, {
                    params: params
                }
            )
        },
        // @Url /v1/auth/read-file/{fidx} 토큰인증없이 읽음
        readFile: async(params) => {
            return await http.get(
                `${URLs.auth}/read-file/${params.fidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/management/{cbidx}/sms-templete
        smsTemplete: async(params) => {
            return await http.get(
                `${URLs.management}/${params.cbidx}/sms-templete`, {
                    params: params
                }
            )
        },
        // @Url /v1/customers/{cbidx}/sms/pre-info 
        smsPreInfo: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/sms/pre-info`, {
                    params: params
                }
            )
        },
        // @Url /v1/customer/{cbidx}/sms-user-list
        smsUserList: async(params) => {
            return await http.get(
                `${URLs.customer}/${params.cbidx}/sms-user-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/payment/sms-payment-info
        smsPaymentInfo: async(params) => {
            return await http.get(
                `${URLs.payment}/sms-payment-info`, {
                    params: params
                }
            )
        },
        // @Url /v1/auth/blogs
        blogs: async(params) => {
            return await http.get(
                `${URLs.auth}/blogs`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-posts/myblog
        myBlog: async(params) => {
            return await http.get(
                `${URLs.sns}/myblog`, {
                    params: params
                }
            )
        },
        // @Url /v1/main/{cbidx}/dash
        dash: async(params) => {
            return await http.get(
                `/v1/main/${params.cbidx}/dash`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-posts/blog/{idx}
        aBlog: async(params) => {
            return await http.get(
                `${URLs.sns}/blog/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/auth/get-common-holiday
        commonHoliday: async(params) => {
            return await http.get(
                `${URLs.auth}/get-common-holiday`, {
                    params: params
                }
            )
        },
        // @Url /v1/auth/get-business-day
        businessDay: async(params) => {
            return await http.get(
                `${URLs.auth}/get-business-day`, {
                    params: params
                }
            )
        },
        // @Url v1/auth/payment/prod-service-fee
        prodServiceFee: async(params) => {
            return await http.get(
                `${URLs.auth}/payment/prod-service-fee`, {
                    params: params
                }
            )
        }
    },
    post: {
        // @Url /v1/management/{cbidx}/sms-templete/{idx}
        smsTemplete: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.management}/${params.cbidx}/sms-templete/${params.idx}`, formData
            )
        },
        // @Url /v1/management/{cbidx}/sms-templete/{idx}/bookmark 
        templeteBookmark: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.management}/${params.cbidx}/sms-templete/${params.idx}/bookmark`, formData
            )
        },
        // @Url /v1/sns-post/write
        write: async(params) => {
            let formData = objectToFormdata(params.data)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.sns}/write`, formData
            )
        },
        // @Url /v1/sns-posts/{cbidx}/push-meeting/{luidx}
        pushMeeting: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/${params.cbidx}/push-meeting/${params.luidx}`, formData
            )
        },
        // @Url /v1/sns-post/{idx}/comment
        comment: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/${params.idx}/comment`, formData
            )
        },
        // @Url /v1/sns-post/like/{luidx}
        like: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/like/${params.luidx}`, formData
            )
        },
        // @Url /v1/sns-post/trust/{luidx}
        trust: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/trust/${params.luidx}`, formData
            )
        },
        // @Url /v1/sns-post/dib/{luidx}
        dib: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/dib/${params.luidx}`, formData
            )
        },
        // @Url /v1/sns-post/comment-like/{luidx}
        commentLike: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/comment-like/${params.luidx}`, formData
            )
        },
        // @Url /v1/sns-post/comment-trust/{luidx}
        commentTrust: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/comment-trust/${params.luidx}`, formData
            )
        },
        // @Url /v1/sns-post/report/{luidx}
        report: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/report/${params.luidx}`, formData
            )
        },
        // @Url /v1/sns-post/comment-report/{luidx}
        commentReport: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/comment-report/${params.luidx}`, formData
            )
        },
        // @Url /v1/members/signature/{luidx}
        signature: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/signature/${params.luidx}`, formData,
            )
        },
        // @Url /v1/auth/upload/img
        uploadImg: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.auth}/upload/img`, formData,
            )
        },
        // @Url /v1/members/file-upload/{luidx}
        fileUpload: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/file-upload/${params.luidx}`, formData
            )
        },
        // @Url /v1/members/{cbidx}/signature/{idx} 
        commonSignature: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/${params.cbidx}/signature/${params.idx}`, formData
            )
        },
        // // @Url /v1/recipients/{cbidx}/state-report/{idx} 미사용
        // stateReport: async(params) => {
        //     let formData = objectToFormdata(params)
        //     if (params.files) {
        //         params.files.forEach((item, i) => {
        //             formData.append(`fileNameList[${i}]`, item.name)
        //             formData.append(`fileEncList[${i}]`, item.encByte)
        //             formData.append(`file[${i}]`, item.file)
        //         })
        //     }
        //     return await http.post(
        //         `${URLs.recipients}/${params.cbidx}/state-report/${params.idx}`, formData
        //     )
        // },
        // @Url /v1/recipients/{cbidx}/state-report/{idx}/{rIdx}
        updateStateReport: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/state-report/${params.idx}/${params.ridx}`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report/{idx}/like
        stateReportLike: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/state-report/${params.idx}/like`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report/{idx}/trust
        stateReportTrust: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/state-report/${params.idx}/trust`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report/{idx}/comment
        stateReportComment: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/state-report/${params.idx}/comment`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report-comment/{idx}/like
        stateCommentLike: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/state-report-comment/${params.idx}/like`, formData
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report-comment/{idx}/trust
        stateCommentTrust: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/state-report-comment/${params.idx}/trust`, formData
            )
        },
        // @Url /v1/sns-posts/{cbidx}/reward
        reward: async(params) => {
            let formData = objectToFormdata(params.data)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.sns}/${params.data.cbidx}/reward`, formData
            )
        },
        // @Url /v1/sns-posts/{cbidx}/staff-meeting
        staffMeeting: async(params) => {
            let formData = objectToFormdata(params.data)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.sns}/${params.data.cbidx}/staff-meeting`, formData
            )
        },
        // @Url /v1/sns-posts/blog
        writeBlog: async(params) => {
            let formData = objectToFormdata(params.data)

            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }

            for (let pair of formData.entries())
                console.log("last formdata before save ", pair[0] + ',' + pair[1])

            return await http.post(
                `${URLs.sns}/blog`, formData
            )
        },
        // @Url /v1/common/{cbidx}/push-sign-noti/{idx}
        pushSignNoti: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `/v1/common/${params.cbidx}/push-sign-noti/${params.idx}`, formData
            )
        },
        // @Url /v1/customers/{cbidx}/sms
        sendSms: async(params) => {
            return await http.post(
                `${URLs.customer}/${params.cbidx}/sms`,
                params, {
                    params: {
                        luidx: params.luidx
                    }
                },
            )
        },
        // @Url /v1/payment/payment-info
        paymentInfo: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/payment-info`, formData
            )
        },
        // @Url /v1/payment/{idx}/cancel 
        paymentCancel: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.idx}/cancel`, formData
            )
        },
        // @Url /v1/payment/{idx}
        payment: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.idx}`, formData
            )
        },
        /* 
        
        // @Url /v1/sns-post/{idx}/comment
        comment: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/${params.idx}/comment`, formData
            )
        },
        // @Url /v1/sns-post/like/{luidx}
        like: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/like/${params.luidx}`, formData
            )
        },
        // @Url /v1/sns-post/trust/{luidx}
        trust: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/trust/${params.luidx}`, formData
            )
        },
        // @Url /v1/sns-post/dib/{luidx}
        dib: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/dib/${params.luidx}`, formData
            )
        },
        // @Url /v1/sns-post/comment-like/{luidx}
        commentLike: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/comment-like/${params.luidx}`, formData
            )
        },
        // @Url /v1/sns-post/comment-trust/{luidx}
        commentTrust: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.sns}/comment-trust/${params.luidx}`, formData
            )
        },
        */
        // @Url /api/v2/sync
        setCommonSyncRequest: async(params) => {
            return await http.post(
                `/api/v2/sync`, params
            )
        },
    },
    delete: {
        // @Url /v1/management/{cbidx}/sms-templete/{idx}
        smsTemplete: async(params) => {
            return await http.delete(
                `${URLs.management}/${params.cbidx}/sms-templete/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/pushs/notices/{luidx}/{idx}
        notices: async(params) => {
            return await http.delete(
                `${URLs.pushs}/notices/${params.luidx}/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/pushs/notices/{luidx}/month
        noticesMonth: async(params) => {
            return await http.delete(
                `${URLs.pushs}/notices/${params.luidx}/month`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report-comment/{idx}/like
        stateCommentLike: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/state-report-comment/${params.idx}/like`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report-comment/{idx}/trust
        stateCommentTrust: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/state-report-comment/${params.idx}/trust`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report/{idx}/comment
        stateReportComment: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/state-report/${params.idx}/comment`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report/{idx}/{rIdx}
        deleteStateReport: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/state-report/${params.idx}/${params.ridx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report/{idx}/like
        stateReportLike: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/state-report/${params.idx}/like`, {
                    params: params
                }
            )
        },
        // @Url /v1/recipients/{cbidx}/state-report/{idx}/trust
        stateReportTrust: async(params) => {
            return await http.delete(
                `${URLs.recipients}/${params.cbidx}/state-report/${params.idx}/trust`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-post/{luidx}
        list: async(params) => {
            return await http.delete(
                `${URLs.sns}/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-post/{luidx}/comment
        comment: async(params) => {
            return await http.delete(
                `${URLs.sns}/${params.luidx}/comment`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-post/like/{luidx}
        like: async(params) => {
            return await http.delete(
                `${URLs.sns}/like/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-post/trust/{luidx}
        trust: async(params) => {
            return await http.delete(
                `${URLs.sns}/trust/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-post/dib/{luidx}
        dib: async(params) => {
            return await http.delete(
                `${URLs.sns}/dib/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-post/comment-like/{luidx}
        commentLike: async(params) => {
            return await http.delete(
                `${URLs.sns}/comment-like/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/sns-post/comment-trust/{luidx}
        commentTrust: async(params) => {
            return await http.delete(
                `${URLs.sns}/comment-trust/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/file-delete-async/{luidx}/{fileidx}
        fileDeleteAsync: async(params) => {
            return await http.delete(
                `/v1/file-delete-async/${params.luidx}/${params.fileIdx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/members/signature/{ludx}/{idx}
        signature: async(params) => {
            return await http.delete(
                `${URLs.members}/signature/${params.luidx}/${params.idx}`
            )
        },
        // @Url /v1/members/file-upload/{luidx}
        fileUpload: async(params) => {
            return await http.delete(
                `${URLs.members}/file-upload/${params.luidx}`
            )
        },
        // @Url /v1/sns-posts/blog
        blog: async(params) => {
            return await http.delete(
                `${URLs.sns}/blog`, {
                    params: params
                }
            )
        },

    }
}


// WEBPACK FOOTER //
// ./src/api/common.js